
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class StatCard extends Vue {
    @Prop({ type: String, required: true }) title!: string
    @Prop({ type: [String, Number], required: true }) value!: string | number
    @Prop({ type: String, default: '' }) unit!: string
}
